import { render } from "./empty-data.vue?vue&type=template&id=50d0091e&ts=true"
import script from "./empty-data.vue?vue&type=script&lang=ts"
export * from "./empty-data.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__